import {flowRight as compose} from 'lodash';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {graphql} from 'react-apollo';

import {withTranslation} from 'react-i18next';

import {GRAPHQL_MUTATION_FORGOT_ACCOUNT_PASSWORD} from '../../common/queries/users';
import ForgotPasswordView from '../components/ForgotPasswordView';

const ForgotPassword = props => {
  const {forgotPassword} = props;

  const [sent, setSent] = useState(false);

  const onSubmit = async values => {
    setSent(true);
    try {
      await forgotPassword(values);
    } catch (e) {
      throw new Error(e);
    }
  };

  return (
    <div className="public-layout">
      <div className="login-layout">
        <ForgotPasswordView {...props} sent={sent} onSubmit={onSubmit} />
      </div>
    </div>
  );
};

ForgotPassword.propTypes = {
  forgotPassword: PropTypes.func,
  t: PropTypes.func,
};

const ForgotPasswordWithApollo = compose(
  withTranslation('user'),
  graphql(GRAPHQL_MUTATION_FORGOT_ACCOUNT_PASSWORD, {
    props: ({mutate}) => ({
      forgotPassword: async ({email}) => {
        const {
          data: {forgotPassword},
        } = await mutate({
          variables: {email},
        });

        return forgotPassword;
      },
    }),
  }),
)(ForgotPassword);

export default ForgotPasswordWithApollo;
